import {
  HorizontallyTruncatedText,
  TruncatedText,
} from '@monorepo/shared/componentsV2/TruncatedLabel';
import { ComplianceCalendarEventStatus } from 'mapistry-shared';
import React from 'react';
import styled, { css } from 'styled-components';
import { EventStatusIndicator } from '../EventStatusIndicator';
import { StyledCalendarEvent } from './styled';

const titleStyles = css`
  flex: 1;
  min-width: 0;
  font-size: 0.75rem;
`;

const VerticalCalendarEventTitle = styled(TruncatedText)`
  ${titleStyles}
  overflow-wrap: anywhere;
`;

const HorizontalCalendarEventTitle = styled(HorizontallyTruncatedText)`
  ${titleStyles}
`;

type CalendarEventProps = {
  status: ComplianceCalendarEventStatus;
  title: string;
  /** From CalendarEventTooltip, which shows the full title when truncated. */
  titleRef: (node: HTMLDivElement | null) => void;
} & (
  | { truncation: 'horizontal' }
  | { truncation: 'vertical'; linesBeforeTruncated: number }
);

export function CalendarEvent(props: CalendarEventProps) {
  const { truncation, status, title, titleRef } = props;

  if (truncation === 'horizontal') {
    return (
      <StyledCalendarEvent>
        <EventStatusIndicator status={status} />
        <HorizontalCalendarEventTitle ref={titleRef}>
          {title}
        </HorizontalCalendarEventTitle>
      </StyledCalendarEvent>
    );
  }

  const { linesBeforeTruncated } = props;
  return (
    <StyledCalendarEvent>
      <EventStatusIndicator status={status} />
      <VerticalCalendarEventTitle
        ref={titleRef}
        $linesBeforeTruncated={linesBeforeTruncated}
      >
        {title}
      </VerticalCalendarEventTitle>
    </StyledCalendarEvent>
  );
}
